import Photo from '../../../components/photo/Photo.vue';
import getCountryIdByCode from '../../../utils/getCountryIdByCode';

const patternPassword = (val) => {
  const isEmpty = !val;
  const lessThen8Symbols = val.length < 8;
  const noDigits = !/\d/.test(val);
  const hasSpaces = /\s/.test(val);
  const noCapitalLetter = !/[A-Z]/.test(val);
  const noLowercaseLetter = !/[a-z]/.test(val);
  const noSpecialCharacter = !/(?=.*[!@#$%^&*.()])/.test(val);
  return {
    isEmpty,
    lessThen8Symbols,
    noDigits,
    hasSpaces,
    noCapitalLetter,
    noLowercaseLetter,
    noSpecialCharacter,
  };
};

const initialUser = {
  phone: '',
  first_name: '',
  last_name: '',
  middle_name: '',
  position: '',
  email: '',
  password: '',
  passwordConfirm: '',
  checkedRules: false,
  checkedPers: false,
  role: null,
  sex: null,
  dealer_id: null,
  object_type_id: null,
  distributor_id: null,
  birthday_on_local: null,
  invite_code: '',
  inn: null,
  company: null,
  country_code: null,
  avatar: [],
};

const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  components: { Photo },
  props: ['invite_code'],
  data() {
    return {
      user: { ...initialUser },
      pageRules: null,
      pagePers: null,
      dialogRules: false,
      dialogPers: false,
      code: '',
      sentCode: false,
      email_redirect: false,
      token: '',
      hidePw: true,
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => pattern.test(v) || 'Поле E-mail заполнено с ошибками',
        password: v => !!v || 'Укажите пароль',
        phone: v => !v
          || !v.length
          || v.length >= 17
          || 'Номер телефона заполнен не полностью',
        code: v => !!v || 'Укажите проверочный код',
      },
      valid: false,
      profile: {},
      searchCity: '',
      searchDealer: '',
      searchDistributor: '',
      searchCompany: '',
      isLoadingObjectTypes: false,
      isLoadingDistributors: false,
      isLoadingDealers: false,
      isLoadingCompanies: false,
      isLoadingCities: false,
      roles: [],
      objects_types: [],
      cities: [],
      dealers: [],
      distributors: [],
      companies: [],
    };
  },
  watch: {
    // eslint-disable-next-line func-names
    'user.role': function (value) {
      this.user.checkedRules = false;
      this.user.checkedPers = false;
      this.$store.getters.ax
        .post('/profiles/api/pages/index', {
          country_id: getCountryIdByCode(this.country_code),
          role: value,
        })
        .then((response) => {
          this.pagePers = response.data.pagePers;
          this.pageRules = response.data.pageRules;
        });
    },
    'user.password': (value) => {
      const messageWrapper = document.getElementById('password_msg');
      messageWrapper.innerHtml = '';
      messageWrapper.innerText = '';
      const checkPassword = patternPassword(value);
      const resultObject = {
        lessThen8Symbols: 'минимум 8 символов',
        noDigits: '1 цифра',
        noCapitalLetter: '1 заглавная латинская буква',
        noLowercaseLetter: '1 прописная латинская буква',
        noSpecialCharacter: '1 специальный символ',
        hasSpaces: 'без пробелов',
      };
      const div = document.createElement('div');
      const beginning = document.createElement('span');
      if (checkPassword.isEmpty) {
        return;
      }
      div.appendChild(beginning);
      Object.keys(resultObject).forEach((key) => {
        const messageDiv = document.createElement('div');
        const color = checkPassword[key] ? 'red' : 'green';
        const icon = document.createElement('i');
        icon.style.color = color;
        icon.innerHTML = checkPassword[key] ? '✗' : '✓';
        messageDiv.appendChild(icon);
        const message = document.createElement('span');
        message.innerHTML = resultObject[key];
        message.style.color = color;
        message.style.marginLeft = '5px';
        messageDiv.appendChild(message);
        div.appendChild(messageDiv);
      });
      messageWrapper.appendChild(div);
    },

    searchCity(city) {
      const app = this;
      if (city && city.length) {
        app.isLoadingCities = true;
        app.$store.getters.ax
          .post('profiles/api/location/cities', { term: city, limit: 30, country_code: app.country_code })
          .then((result) => {
            app.cities = result.data.cities;
          })
          .finally(() => {
            app.isLoadingCities = false;
          });
      }
    },
    searchCompany(inn) {
      const app = this;
      if (inn && inn.length && (inn.length === 10 || inn.length === 12)) {
        app.isLoadingCompanies = true;
        app.$store.getters.ax
          .post('profiles/api/companies/find-by-inn', { inn })
          .then((result) => {
            app.companies = result.data.data;
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          })
          .finally(() => {
            app.isLoadingCompanies = false;
          });
      }
    },
    searchDistributor(name) {
      const app = this;
      if (name && name.length) {
        app.user.dealer_id = null;
        app.dealers = [];
        app.isLoadingDistributors = true;
        app.$store.getters.ax
          .post('profiles/api/distributors', { name, limit: 30 })
          .then((result) => {
            app.distributors = result.data.data;
          })
          .finally(() => {
            app.isLoadingDistributors = false;
          });
      }
    },
    searchDealer(name) {
      const app = this;
      if (name && name.length) {
        app.isLoadingDealers = true;
        app.$store.getters.ax
          .post('profiles/api/dealers', {
            name,
            distributor_id: app.user.distributor_id,
            limit: 30,
          })
          .then((result) => {
            app.dealers = result.data.data;
          })
          .finally(() => {
            app.isLoadingDealers = false;
          });
      }
    },
  },
  computed: {
    requireRules() {
      return this.$store.state.settings.register_rules === true;
    },
    requirePers() {
      return this.$store.state.settings.register_pers === true;
    },
    type() {
      if (this.email_redirect) {
        return 'email_noprofile_or_unregistered';
      }
      if (this.$store.state.settings.registration === 'unregistered_by_phone') {
        return 'sms_noprofile_or_unregistered';
      }
      if (this.$store.state.settings.registration === 'existing_by_phone') {
        return 'sms_profile_unregistered';
      }
      if (this.$store.state.settings.registration === 'free_by_phone') {
        return 'sms_noprofile';
      }
      if (this.settings && this.settings.registration === 'free_by_email') {
        return 'email_noprofile';
      }
      return null;
    },
    isSmsNoProfile() {
      return this.type === 'sms_noprofile';
    },
    isEmailNoProfile() {
      return this.type === 'email_noprofile';
    },
    isShowGender() {
      return this.$store.state.settings.register_gender;
    },
    comparePasswords() {
      return this.user.password === this.user.passwordConfirm
        ? true
        : 'Пароли не совпадают';
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
    phoneMask() {
      const masks = {
        russia8: '8 (###) ###-####',
        russia7: '+7 (###) ###-####',
        belarus: '+375 (##) ###-####',
      };

      // eslint-disable-next-line no-unused-vars
      const russia7Regex = /^\+?7/; // Номера РФ начинаются с 7
      const russia8Regex = /^8/; // Номера РФ начинаются с 8
      const belarusRegex = /^\+?37?5?/; // Номера Беларуси начинаются с 375

      if (russia8Regex.test(this.user.phone)) {
        return masks.russia8;
      }
      if (belarusRegex.test(this.user.phone)) {
        return masks.belarus;
      }

      return masks.russia7;
    },
    role() {
      return (
        this.user.role && this.roles.find(el => el.value === this.user.role)
      );
    },
  },
  methods: {
    /** Предзагрузка данных в форму если участник добавлен в админке */
    LoadRegInfo() {
      const app = this;
      app.$store.getters.ax
        .post('profiles/api/register/info', { phone: app.user.phone })
        .then((response) => {
          const { profile } = response.data;
          if (profile) {
            app.user.first_name = profile.first_name;
            app.user.last_name = profile.last_name;
            app.user.middle_name = profile.middle_name;
            app.user.email = profile.email;
          }
        });
    },
    /** Фокус на указанное поле */
    Focus(id) {
      this.$nextTick(() => {
        document.getElementById(id).focus();
      });
    },
    /** Сброс полей формы */
    Reset() {
      this.user = { ...initialUser };
      this.sentCode = false;
      this.code = '';
      this.token = null;
      this.dialogRules = false;
      this.dialogPers = false;
      this.searchCity = '';
      this.searchDealer = '';
      this.searchDistributor = '';
      this.searchCompany = '';
      this.cities = [];
      this.dealers = [];
      this.distributors = [];
      this.companies = [];

      this.Focus('regPhone');
    },
    /** Отправка проверочного СМС кода */
    SendCode() {
      const app = this;
      let url = 'api/token/get-email';
      const dataRequest = { type: app.type };
      if (app.isEmailNoProfile || this.email_redirect) {
        dataRequest.email = app.user.email;
      }
      if (app.isSmsNoProfile && !this.email_redirect) {
        url = 'profiles/api/register/get-sms';
        dataRequest.phone = app.user.phone;
      }
      app.$store.getters.axl
        .post(url, dataRequest)
        .then(({ data }) => {
          if (app.isSmsNoProfile) {
            // app.email_redirect = data.email_redirect;
            this.$nextTick(() => {
              app.email_redirect = data.email_redirect;
            });
            app.country_code = data.country_code;
          }
          if (!data.email_redirect) {
            app.sentCode = true;
            app.Focus('regCode');
          }
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regPhone');
        });
    },
    /** Проверка кода полученного в СМС */
    CheckCode() {
      const app = this;
      let url = 'api/token/check-email';
      const data = { type: app.type, code: app.code };
      if (app.isEmailNoProfile || this.email_redirect) {
        data.email = app.user.email;
      }
      if (app.isSmsNoProfile && !this.email_redirect) {
        url = 'api/token/check-sms';
        data.phone = app.user.phone;
      }
      app.$store.getters.axl
        .post(url, data)
        .then((response) => {
          app.token = response.data.token;
          app.Focus('password');
          app.LoadRegInfo();
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
          app.Focus('regCode');
        });
    },
    /** Отправка регистрационных данных в приложение */
    Register() {
      const app = this;
      app.user.invite_code = app.invite_code;
      const formData = { ...app.user };
      formData.token = app.token;
      formData.country_code = app.country_code;
      formData.email_redirect = app.email_redirect;

      if (!app.requireRules) {
        formData.checkedRules = true;
      }
      if (!app.requirePers) {
        formData.checkedPers = true;
      }

      app.$store.getters.axl
        .post('profiles/api/register', formData)
        .then((response) => {
          app.$store.commit('SetLogged', response.data);
          app.Reset();
          app.$store.dispatch('ShowInfo', 'Добро пожаловать в программу!');
          app.$router.push('/dashboard');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
    async GetObjectTypes() {
      const app = this;
      app.$store.getters.ax
        .post('profiles/api/register/object-types')
        .then((result) => {
          app.objects_types = result.data.data;
        });
    },
    async GetRoles() {
      const app = this;
      app.$store.getters.ax
        .post('profiles/api/roles/registration')
        .then((result) => {
          app.roles = result.data.data;
        });
    },
  },
  mounted() {
    if (this.$store.state.settings.extranet === true) {
      this.$router.push('/');
    }
    this.$store.dispatch('GetSettings');
    this.Focus('regPhone');
    this.GetObjectTypes();
    this.GetRoles();
  },
};
